export interface DateRange {
  start: string | null;
  end: string | null;
}

export interface TimeRange {
  start: string | null;
  end: string | null;
}

export interface FilterOption {
  value: string;
  label: string;
}

export type SortDirection = 'asc' | 'desc';

export interface SortState {
  field: string;
  direction: SortDirection;
}

export interface FilterFieldConfig<T = any> {
  type: 'select' | 'date' | 'time';
  label: string;
  field: string;
  options?: FilterOption[] | Record<string, FilterOption[]> | string[];
  isMulti?: boolean;
}

export interface UserFilterFieldConfig<T = any> {
  type: 'select' | 'date' | 'time';
  label: string;
  field: string;
  options?: FilterOption[] | Record<string, FilterOption[]> | string[];
  isMulti?: boolean;
}


export interface FilterConfig<T = any> {
  fields: FilterFieldConfig[];
  sortableFields?: string[];
  defaultState: FilterState<T>;
}

export interface UserFilterConfig<T = any> {
  fields: UserFilterFieldConfig[];
  sortableFields?: string[];
  defaultState: FilterState<T>;
}

export interface FilterState<T = any> {
  regularFilters: Record<string, string[]>;
  dateRanges: Record<string, DateRange>;
  timeRange: TimeRange;
  sort: SortState;
}

export const createDefaultTimeRange = (): TimeRange => ({
  start: null,
  end: null
});

export const createDefaultFilterState = <T = any>(override?: Partial<FilterState<T>>): FilterState<T> => ({
  regularFilters: {},
  dateRanges: {},
  timeRange: { start: null, end: null },
  sort: { field: 'id', direction: 'asc' },
  ...override
});

export interface UpdateDateRangeParams {
  field: string;
  range: DateRange;
}

export type MaintenanceTableType = 'processing' | 'processed'
export type TableType = MaintenanceTableType | 'area' | 'supervisor' | 'areaController'
export type TableSubType = 'active' | 'inactive' | MaintenanceTableType
